// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceSummaryRecordDto } from './IInvoiceSummaryRecordDto';
import {
    IInvoiceSummaryRecordDtoFromJSON,
    IInvoiceSummaryRecordDtoFromJSONTyped,
    IInvoiceSummaryRecordDtoToJSON,
    IInvoiceSummaryRecordDtoToJSONTyped,
} from './IInvoiceSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoInvoiceSummaryRecordDto
 */
export interface IReportSummaryGroupDtoInvoiceSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoInvoiceSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IInvoiceSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoInvoiceSummaryRecordDto
     */
    subsidiary_records?: Array<IInvoiceSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoInvoiceSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoInvoiceSummaryRecordDto(value: object): value is IReportSummaryGroupDtoInvoiceSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoInvoiceSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoInvoiceSummaryRecordDto {
    return IReportSummaryGroupDtoInvoiceSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoInvoiceSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoInvoiceSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IInvoiceSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoInvoiceSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoInvoiceSummaryRecordDto {
    return IReportSummaryGroupDtoInvoiceSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoInvoiceSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoInvoiceSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IInvoiceSummaryRecordDtoToJSON)),
    };
}

